import { useTranslation } from 'react-i18next';
import { siteConfig, whatsappUrl } from '@/content/site';
import { WhatsAppIcon, MailIcon, PinIcon, InstagramIcon, FacebookIcon } from '@/shared/components/Icons';
import styles from './Contact.module.css';

export function Contact() {
  const { t } = useTranslation();

  return (
    <section id="contacto" className={styles.section}>
      <div className={`container ${styles.card}`}>
        <div className={styles.head}>
          <span className="eyebrow">{t('nav.contact')}</span>
          <h2>{t('contact.title')}</h2>
          <p className={`lead ${styles.subtitle}`}>{t('contact.subtitle')}</p>
        </div>

        <div className={styles.grid}>
          <a
            className={styles.channel}
            href={whatsappUrl(t('contact.whatsappMessage'))}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon width={24} height={24} className={styles.icon} />
            <span className={styles.label}>{t('contact.whatsapp')}</span>
            <span className="text-soft">+52 777 260 3831</span>
          </a>

          <a className={styles.channel} href={`mailto:${siteConfig.contact.email}`}>
            <MailIcon width={24} height={24} className={styles.icon} />
            <span className={styles.label}>{t('contact.email')}</span>
            <span className="text-soft">{siteConfig.contact.email}</span>
          </a>

          <div className={styles.channel}>
            <PinIcon width={24} height={24} className={styles.icon} />
            <span className={styles.label}>{t('contact.location')}</span>
            <span className="text-soft">{siteConfig.location}</span>
          </div>
        </div>

        <div className={styles.footerRow}>
          <div className={styles.social}>
            <span className="text-soft">{t('contact.followUs')}</span>
            <a
              href={siteConfig.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon width={22} height={22} />
            </a>
            <a
              href={siteConfig.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon width={22} height={22} />
            </a>
          </div>
          <p className={styles.disclaimer} role="note">
            ⚠️ {t('contact.disclaimer')}
          </p>
        </div>
      </div>
    </section>
  );
}
